const MOBILE = window.matchMedia('(max-width: 749px)');
const REDUCE_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
const SHOW_AFTER = 100;

const button = document.querySelector('[data-mg-back-to-top]');

if (button) {
  const scrollContainer = () => document.scrollingElement || document.documentElement;

  let timer;

  const update = () => {
    const show = MOBILE.matches && scrollContainer().scrollTop > SHOW_AFTER;
    button.classList.toggle('is-visible', show);
    if (show) {
      button.removeAttribute('tabindex');
      button.removeAttribute('aria-hidden');
    } else {
      button.tabIndex = -1;
      button.setAttribute('aria-hidden', 'true');
    }
  };

  const onScroll = () => {
    clearTimeout(timer);
    timer = setTimeout(update, 100);
  };

  document.querySelector('.page-wrapper')?.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('scroll', onScroll, { passive: true });
  MOBILE.addEventListener('change', update);

  button.addEventListener('click', (event) => {
    event.preventDefault();
    if (!MOBILE.matches) return;

    const top = document.getElementById('page-top');
    const container = scrollContainer();
    const behavior = REDUCE_MOTION.matches ? 'auto' : 'smooth';
    if (top) {
      top.scrollIntoView({ block: 'start', behavior });
    } else {
      container.scrollTo({ top: 0, behavior });
    }
  });

  update();
}
